import { ComponentChildren } from 'preact';
import { Grid } from '../UNSAFE_Grid';
import { Flex } from '../UNSAFE_Flex';
import { GutterSize } from './BaseCardViewUtils';
import { cardViewVars } from './themes/BaseCardViewContract.css';

type Props = {
  children: ComponentChildren;
  layout: 'grid' | 'flex';
  gutterSize: GutterSize;
  columns: number;
};

export function BaseCardViewLayout({ children, layout, gutterSize, columns }: Props) {
  const gap = cardViewVars.gutterSize[gutterSize];
  if (layout === 'grid') {
    return columns < 1 ? null : (
      <Grid gridTemplateColumns={`repeat(${columns}, 1fr)`} gap={gap}>
        {children}
      </Grid>
    );
  } else {
    return (
      <Flex wrap="wrap" gap={gap}>
        {children}
      </Flex>
    );
  }
}
